import React from 'react';
import Box from '@mui/material/Box';
import { Typo } from 'components/primitives';
import useStyles from './AcceptTabSnippet.style';
import { ResourceType } from 'interfaces/ResourceType';
import InsertChartIcon from '@mui/icons-material/InsertChart';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import theme from '../../../theming/theme';
import useMediaQuery from '@mui/material/useMediaQuery';

const PersonnelContainer: React.FC<{
  tabIndex: number;
  name: ResourceType;
  totalRequest: number;
  totalApprove: number;
}> = ({ tabIndex, name, totalRequest, totalApprove }) => {
  const classes = useStyles();
  const active: boolean = tabIndex === 0;
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <React.Fragment>
      <Box
        className={active ? classes.tabContainerActive : classes.tabContainer}
        sx={{
          borderTopRightRadius: '4px',
          borderBottomRightRadius: '4px',
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px',
        }}>
        <Typo className={active ? classes.titleActive : classes.title}>
          {name === 'ambulance' ? 'Ambulances' : 'Personnel'}
        </Typo>
        <Box flexDirection='row' display='flex'>
          <Box flexDirection='row' display='flex' alignItems='center'>
            <InsertChartIcon sx={{ fontSize: '20px', color: '#2961FD' }} />
            {!isMobile && (
              <Typo variant='caption' className={classes.subtitle}>
                Requested
              </Typo>
            )}
            <Typo className={classes.count}>{totalRequest}</Typo>
          </Box>
          <Box flexDirection='row' display='flex' alignItems='center'>
            <CheckCircleIcon sx={{ fontSize: '20px', color: '#2961FD' }} />
            {!isMobile && (
              <Typo variant='caption' className={classes.subtitle}>
                Accepted
              </Typo>
            )}
            <Typo className={classes.count}>{totalApprove}</Typo>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default PersonnelContainer;
